import {
  deleteAction,
  getAction,
  putAction,
  postAction
} from '@/api/manage'

//获取省控线列表
export const getLineList = (params) => getAction("/gkApplicationLines/scoreList", params);
//获取一分一段列表
export const getOneScoreList = (params) => getAction("/gkApplicationScore/sectionList", params);
//获取学校
export const getSchoolList = (params) => getAction("/gkSchool/getSchoolNameList", params);

export const getSchoolListBySchoolRank = (params) => getAction("/gkSchoolRank/getSchoolNameList", params);
//获取学校详情
export const getSchoolInfo = (params) => getAction("/gkSchool/querySchoolById", params);
//获取用户信息
export const userqueryById = (params) => getAction("/course/user/selectById", params);
//同分去向
export const getSame = (params) => getAction("/gkApplicationDegree/sameScoreDirection", params);

//艺术同分去向
export const getArtSame = (params) => getAction("/gaokao/gkApplicationDegreeArt/sameScoreArtDirection", params);

//体育同分去向
export const getSportsSame = (params) => getAction("/gaokao/gkApplicationDegreeSports/sameScoreSportsDirection", params);
//春季同分去向
export const getSpringSame = (params) => getAction("/gaokao/gkApplicationDegreeSpring/sameScoreSpringDirection", params);
//根据选科查询学校
export const axkQuerySchool = (params) => getAction("/gkSchool/getSchoolList", params);
//查询学校下的专业
export const schoolQueryMajor = (params) => getAction("/examination/fore/getSchoolSpeList", params);
// 获取志愿表
export const getVolunteer = (params) => getAction("/AISelector/getApplicationList", params);
// 志愿表排序
export const sortVolunteer = (params) => putAction("/gkApplication/updateApplication", params);
// 删除志愿表
export const delVolunteer = (params) => deleteAction("/gkApplication/deleteApplication", params);
// 测评添加数据库
export const addAppraisal = (params) => postAction("/examination/gkCharacterUser/add", params);
// 获取测评结果
export const getAppraisal = (params) => getAction("/examination/gkOccupation/recommend", params);
// 获取测评结果 无token
export const getAppraisalNo = (params) => getAction("/examination/fore/recommend", params);
// 测评获取个人信息
export const getAppraisalInfo = (params) => getAction("/examination/gkOccupation/selectByUserId", params);
// 删除所有志愿
export const delVolunteerAll = (params) => deleteAction("/gkApplication/clearApplication", params);
// 换一换志愿
export const AIChange = (params) => getAction("/AISelector/replaceItem", params);

export const AIArtChange = (params) => getAction("/AISelector/replaceArtItem", params)
export const AISportsChange = (params) => getAction("/AISelector/replaceSportsItem", params);

export const AISpringChange = (params) => getAction("/AISelector/replaceSpringItem", params);
// 到处excel
export const getExcel = (params) => getAction("/gkApplication/exportXlsByGkUser", params);

export const setVip = (params) => getAction("/gkUser/setVip", params);

export const filingSearch = (params) => getAction("/AISelector/filingSearch", params);